import flatten from 'lodash/flatten';
import { getTransformedObjectCoordinates } from '../utils';

export const getCoordinatesFromObjects = (objects, parentMatrix) =>
  flatten(
    objects
      .map(obj => getTransformedObjectCoordinates(obj, parentMatrix))
      .toJS(),
  );
